import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

import Layout from '@/components/Layout';
import { createAuthRoutes } from '@packet/management';
import Logo from '@assets/icon/logo.svg?react';
import LogoFull from '@assets/icon/logo-full.svg?react';
import '../../packages/management/src/style/global.scss';

function App() {
  const { login, isAuthenticated } = useAuthStore();
  const authRoutes = createAuthRoutes({
    logo: <Logo />,
    logoFull: <LogoFull />,
    onSuccess: async (user) => {
      console.log('user: ', user);
      login(user);
      return;
    },
  });
  return (
    <Router>
      <Routes>
        {/* 认证相关路由 */}
        {authRoutes}

        {/* 主要应用路由 */}
        <Route path="/*" element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />} />

        {/* 默认重定向 */}
        <Route path="/" element={<Navigate to="/transactions" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
